import React from 'react';
import {connect} from "react-redux";
import Select from 'react-select';
import Pagination from 'react-js-pagination';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import ResultCount from '../components/List/ResultCount';
import SearchField from '../components/SearchField';
import ReplenishmentItem from './ReplenishmentItem';
import DatePickerFilter from './DatePickerFilter';
import MultiSortableTableHeader from "../components/MultiSortableTableHeader";

import {
    changePage,
    setPageSize,
    fetchReplenishments,
    fetchModules,
    updateReplenishmentQuery,
    updateCreatedBetween,
    updateStatusFilter,
    updateModuleFilter,
    restoreReplenishment,
    markReplenishmentAsShipped,
    markReplenishmentAsUnshipped,
    updateSortProperty
} from './reducer';

import {buildCsvDownloadUrl} from "../services/ReplenishmentModule";
import ModuleFilter from "../components/ModuleFilter";

export class ReplenishmentManager extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            dropDownMenuOpen: false
        };
        this.handleQueryChange = this.handleQueryChange.bind(this);
        this.handleCreatedAfterChange = this.handleCreatedAfterChange.bind(this);
        this.handleCreatedBeforeChange = this.handleCreatedBeforeChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.applyStatusFilter = this.applyStatusFilter.bind(this);
        this.applyModuleFilter = this.applyModuleFilter.bind(this);
        this.toggleDropDownMenu = this.toggleDropDownMenu.bind(this);
        this.downloadCsv = this.downloadCsv.bind(this);
    }

    handlePageChange(newPage) {
        this.props.changePage(newPage - 1);
    }

    handleQueryChange(query) {
        this.props.updateReplenishmentQuery(query);
    }

    handleCreatedAfterChange(createdAfter) {
        this.props.updateCreatedBetween(createdAfter.utc(), this.props.filters.createdBefore);
    }

    handleCreatedBeforeChange(createdBefore) {
        this.props.updateCreatedBetween(this.props.filters.createdAfter, createdBefore.utc());
    }

    toggleDropDownMenu() {
        this.setState(prevState => ({
            dropDownMenuOpen: !prevState.dropDownMenuOpen
        }));
    }

    applyStatusFilter(filterOption) {
        this.props.updateStatusFilter(filterOption.value);
    }

    applyModuleFilter (modulesSelected) {

        const selectedModuleValues = modulesSelected.map(selectedModule => selectedModule.value);

        this.props.updateModuleFilter(selectedModuleValues);
    }

    componentDidMount() {
        this.props.fetchModules();
        this.props.fetchReplenishments();
    }

    downloadCsv() {
        buildCsvDownloadUrl(this.props.query, this.props.filters).then((url) => {
            window.location.assign(url);
        });
    }

    render() {

        const moduleOptions = this.props.modules.map((module) => {
            return {
                value: module.name.toString(),
                label: module.name.toString()
            };
        });

        const statusFilterOptions = [
            {value: 'ALL', label: 'alle'},
            {value: 'IN_PROGRESS', label: 'in Bearbeitung'},
            {value: 'SHIPPED', label: 'versendet'},
            {value: 'CANCELED', label: 'storniert'}
        ];

        const selectedStatusOption = statusFilterOptions.find(option => option.value === this.props.filters.processingStatus);

        return (
            <div className="animated fadeIn" style={{fontSize: 'small'}}>
                <div className="card">
                    <div className="card-body">
                        <h4 className="card-title">Ausgeführte Nachversorgungen</h4>
                        <div className="row">
                            <div className={"col-2"}>
                                <label>Eingegangen von</label>
                                <DatePickerFilter date={this.props.filters.createdAfter}
                                                  onChange={this.handleCreatedAfterChange}/>
                            </div>
                            <div className={"col-2"}>
                                <label>Eingegangen bis</label>
                                <DatePickerFilter date={this.props.filters.createdBefore}
                                                  onChange={this.handleCreatedBeforeChange}/>
                            </div>
                            <div className="col-2">
                                <label>Bearbeitungsstatus</label>
                                <Select
                                    name="status"
                                    value={selectedStatusOption}
                                    onChange={this.applyStatusFilter}
                                    options={statusFilterOptions}
                                />
                            </div>
                            <div className="col-2">
                                <label>Modulauswahl</label>
                                <ModuleFilter
                                    moduleOptions={moduleOptions}
                                    onChange={this.applyModuleFilter}
                                />
                            </div>
                            <div className="col-2">
                                <label htmlFor="query">Suche</label>
                                <SearchField className="mb-2 mr-sm-2 mb-sm-0" value={this.props.query} onCommit={this.handleQueryChange}/>
                            </div>
                            <div className="col-lg-2">
                                <Dropdown isOpen={this.state.dropDownMenuOpen} toggle={this.toggleDropDownMenu} style={{marginTop:'29px'}} className="float-right">
                                    <DropdownToggle caret>
                                        ...weitere Aktionen
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem onClick={this.downloadCsv}>CSV-Download</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize
                                             + this.props.replenishments.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <table className="table table-striped">
                                    <thead>
                                    <tr>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "id", sortPropertyName: "ID"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <th>Menge</th>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "createdAt", sortPropertyName: "Eingegangen"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "exportedAt", sortPropertyName: "Nachschub ausgelöst"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader sortProperties={[{sortProperty: "retailerGln", sortPropertyName: "Händler-GLN"},
                                            {sortProperty: "storeGln", sortPropertyName: "Filial-GLN"}]}
                                                                  propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                                  sortDirection={this.props.sortProperties.sortDirection}
                                                                  updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "storeZipCode", sortPropertyName: "PLZ"},
                                                {sortProperty: "storeCity", sortPropertyName: "Ort"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "moduleName", sortPropertyName: "Modul"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader sortProperties={[{sortProperty: "articleErpIdno", sortPropertyName: "ERP-Artikelnr."},
                                            {sortProperty: "articleGtin", sortPropertyName: "GTIN"},
                                            {sortProperty: "articleName", sortPropertyName: "Details"}]}
                                                                  propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                                                  sortDirection={this.props.sortProperties.sortDirection}
                                                                  updateSortProperty={this.props.updateSortProperty}/>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "articleVendorArticleNumber", sortPropertyName: "Hersteller-Artikelnr."}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <th>Status</th>
                                        <MultiSortableTableHeader
                                            sortProperties={[{sortProperty: "shippedAt", sortPropertyName: "Versendet am"}]}
                                            propertyToSortBy={this.props.sortProperties.propertyToSortBy}
                                            sortDirection={this.props.sortProperties.sortDirection}
                                            updateSortProperty={this.props.updateSortProperty}/>
                                        <th>Bestand bei Freigabe</th>
                                        <th>Aktionen</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.props.replenishments.map((replenishment) => {
                                        return <ReplenishmentItem {...replenishment}
                                                                  key={replenishment.id}
                                                                  markReplenishmentAsShipped={this.props.markReplenishmentAsShipped}
                                                                  markReplenishmentAsUnshipped={this.props.markReplenishmentAsUnshipped}
                                                                  restoreReplenishment={this.props.restoreReplenishment}/>;
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <Pagination
                                    activePage={this.props.pagination.page + 1}
                                    itemsCountPerPage={this.props.pagination.pageSize}
                                    totalItemsCount={this.props.pagination.totalElements}
                                    pageRangeDisplayed={20}
                                    onChange={this.handlePageChange}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-2 pull-left">
                                <Select
                                    name="pageSize"
                                    value={this.props.pagination.pageSize}
                                    onChange={(select) => this.props.setPageSize(select.value)}
                                    options={[
                                        {value: '25', label: '25'},
                                        {value: '50', label: '50'},
                                        {value: '100', label: '100'},
                                        {value: '200', label: '200'},
                                        {value: '1000', label: '1000'}
                                    ]}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12">
                                <ResultCount start={(this.props.pagination.page) * this.props.pagination.pageSize + 1}
                                             end={(this.props.pagination.page) * this.props.pagination.pageSize
                                             + this.props.replenishments.length}
                                             total={this.props.pagination.totalElements}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        replenishments: state.replenishment.get('replenishments').toJS(),
        filters: state.replenishment.get('filters').toJS(),
        query: state.replenishment.get('query'),
        pagination: state.replenishment.get('pagination').toJS(),
        sortProperties: state.replenishment.get('sortProperties').toJS(),
        modules: state.replenishment.get('modules').toJS()
    };
}

const ConnectedReplenishmentManager = connect(mapStateToProps, {
    changePage,
    setPageSize,
    updateReplenishmentQuery,
    updateCreatedBetween,
    fetchReplenishments,
    fetchModules,
    updateStatusFilter,
    updateModuleFilter,
    restoreReplenishment,
    markReplenishmentAsShipped,
    markReplenishmentAsUnshipped,
    updateSortProperty
})(ReplenishmentManager);

export default ConnectedReplenishmentManager;



// WEBPACK FOOTER //
// ./src/admin/replenishment/ReplenishmentManager.js